export default "__VITE_ASSET__FChfNt5e__"